module.exports = __webpack_public_path__ + "static/img/icon5-12.c4f65f6c.png";